<section class="flex col a-center j-center">
    <span class="h2-logo-caption">{{ yeshiva }}</span>
    <!-- 4px tagline at 40% opacity is a logo flourish: hidden from AT so it is not judged for contrast -->
    <span class="h5-logo-caption" aria-hidden="true">{{ whyInternet }}</span>
</section>
